import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class MaquinaMovimientoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerMovimientos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_movimientoTOmaquina_movimientoInputType) {
            maquina_movimiento {
              obtenerMovimientos(paginaActual: 1, filtro: $filtro) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    numero_placa
                    fecha_asignacion
                    origen
                    destino
                    detalle_destino
                    fecha_entrega
                    numero_contrato
                    fecha_contrato
                    fecha_vigencia_contrato
                    fecha_termino_contrato
                    cerrado
                    tipo_garantia_codigo
                    nro_documento_garantia
                    fecha_garantia
                    tipo_destinatario_destino_codigo
                    tipo_destinatario_codigo
                    tipo_dte_codigo
                    sucursal_codigo
                    direccion_codigo
                    direccion_nombre
                    cliente_proveedor_rut
                    numero_documento_movimiento
                    codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_movimiento.obtenerMovimientos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerMovimientosMaqEsp(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_movimientoTOmaquina_movimientoInputType) {
            maquina_movimiento {
              obtenerMovimientosMaquinaEsp(paginaActual: 1, filtro: $filtro) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    fecha_asignacion
                    fecha_entrega
                    numero_contrato
                    numero_documento_movimiento
                    nro_documento_garantia
                    fecha_garantia
                    tipo_garantia_codigo
                    codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_movimiento.obtenerMovimientosMaquinaEsp;
            callback({ mensajes, respuesta });
        });
    }
    obtenerMovimientosPDF(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_movimientoTOmaquina_movimientoInputType) {
            maquina_movimiento {
              obtenerMovimientos(paginaActual: 1, filtro: $filtro) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_movimiento.obtenerMovimientos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerMovimientosPDFEspecifico(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_movimientoTOmaquina_movimientoInputType) {
            maquina_movimiento {
              obtenerMovimientosEspecifico(paginaActual: 1, filtro: $filtro) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_movimiento.obtenerMovimientosEspecifico;
            callback({ mensajes, respuesta });
        });
    }
    guardar(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: maquina_movimientoInputType) {
            maquina_movimiento {
              guardar(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  empresa_rut
                  tipo_destinatario_destino_codigo
                  numero_documento_movimiento
                  tipo_dte_codigo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_movimiento.guardar;
            callback({ mensajes, respuesta });
        });
    }
    /**
     * Actualiza un movimiento existente por PK (edición máquina). No debe usarse para asignaciones nuevas.
     * El API `guardar` siempre inserta histórico (Agregar).
     */
    modificarMovimiento(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: maquina_movimientoInputType) {
            maquina_movimiento {
              modificarMovimiento(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  codigo
                  empresa_rut
                  tipo_destinatario_destino_codigo
                  numero_documento_movimiento
                  tipo_dte_codigo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_movimiento.modificarMovimiento;
            callback({ mensajes, respuesta });
        });
    }
}
MaquinaMovimientoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MaquinaMovimientoService_Factory() { return new MaquinaMovimientoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: MaquinaMovimientoService, providedIn: "root" });
